export default __webpack_public_path__ + "static/media/correct.5b2051d9.mp3";